import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36a146ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signatories" }
const _hoisted_2 = { class: "row ma-0 ml-2" }
const _hoisted_3 = { class: "col-8 ml-0 mr-0" }
const _hoisted_4 = {
  key: 0,
  class: "col-4 ml-0 mr-0 right"
}
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 ml-0 mr-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "validation-msg error" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg mr-2" }),
    /*#__PURE__*/_createTextVNode("You currently don’t have an authorised signatory. Please click the Manage Authorised Signatories button.")
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "row"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 ml-0 mr-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "validation-msg error" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg mr-2" }),
    /*#__PURE__*/_createTextVNode("If not correct, click on the Manage Authorised Signatories button. At least one authorised signatory is required to proceed. ")
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "question col-12 ml-2" }
const _hoisted_13 = { style: {"min-width":"250px"} }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "radio-button-group ml-4" }
const _hoisted_16 = { class: "radio" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt mt-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Yes")
], -1))
const _hoisted_19 = { class: "radio" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt mt-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "No")
], -1))

export function render(_ctx, _cache) {
  const _component_ViewSignatoryModal = _resolveComponent("ViewSignatoryModal")
  const _component_ContinueToManageSignatories = _resolveComponent("ContinueToManageSignatories")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.answered() ? 'answered' : '')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.qWording), 1)
        ]),
        (_ctx.signatories?.length == 0 || _ctx.isConfirmed === false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "btn btn-secondary sml",
                onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.continueToManageSignatoriesModalOpened = true), ["prevent","stop"]))
              }, "Manage Authorised Signatories")
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.signatories?.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      (_ctx.isConfirmed === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h4", _hoisted_13, [
            _createTextVNode("Are the Authorised Signatories listed correct?   "),
            _createElementVNode("button", {
              class: "btn btn-outline sml",
              disabled: _ctx.signatories?.length == 0,
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.showSignatoryModal = true))
            }, "View Authorised Signatories", 8, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "uniqueIdName",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.localConfirmed) = $event)),
                disabled: _ctx.signatories?.length == 0,
                onChange: _cache[3] || (_cache[3] = $event => (_ctx.emitConfirmed(_ctx.localConfirmed))),
                value: true
              }, null, 40, _hoisted_17), [
                [_vModelRadio, _ctx.localConfirmed]
              ]),
              _hoisted_18
            ]),
            _createElementVNode("label", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "uniqueIdName",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.localConfirmed) = $event)),
                disabled: _ctx.signatories?.length == 0,
                onChange: _cache[5] || (_cache[5] = $event => (_ctx.emitConfirmed(_ctx.localConfirmed))),
                value: false
              }, null, 40, _hoisted_20), [
                [_vModelRadio, _ctx.localConfirmed]
              ]),
              _hoisted_21
            ])
          ])
        ])
      ])
    ], 2),
    (_ctx.showSignatoryModal)
      ? (_openBlock(), _createBlock(_component_ViewSignatoryModal, {
          key: 0,
          signatories: _ctx.signatories,
          "onUpdate:signatories": _cache[6] || (_cache[6] = $event => ((_ctx.signatories) = $event)),
          onCloseModal: _cache[7] || (_cache[7] = $event => (_ctx.showSignatoryModal = false))
        }, null, 8, ["signatories"]))
      : _createCommentVNode("", true),
    (_ctx.continueToManageSignatoriesModalOpened)
      ? (_openBlock(), _createBlock(_component_ContinueToManageSignatories, {
          key: 1,
          modalOpened: _ctx.continueToManageSignatoriesModalOpened,
          onClose: _cache[8] || (_cache[8] = $event => (_ctx.continueToManageSignatoriesModalOpened = false)),
          onContinue: _cache[9] || (_cache[9] = $event => (_ctx.goToManageAuthorisedSignatories()))
        }, null, 8, ["modalOpened"]))
      : _createCommentVNode("", true)
  ]))
}